import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import "../styles/orderlist.css";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { OrderApi } from "api/order.api";
import Loader from "../components/loader/loader";
import OrderItemSummary from "components/weddigservice/order/orderItemSummary";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EVENT_NAME, ORDER } from "utils/constants";
import { getLocation } from "utils/helper";
import MapComponent from "components/utils/Map";
import { CustomerApi } from "api/customer.api";
import AnalyticsService from "services/analytics.service";

export default function OrderDetailsPage() {
  const { orderId } = useParams();
  const [queryParams] = useSearchParams();
  const [isOrderPlacedNow, setIsOrderPlacedNow] = useState(null);

  const [orderDetails, setOrderDetails] = useState(null);
  const [deviceLocation, setDeviceLocation] = useState(getLocation());

  async function fetchOrderDetails() {
    const response = await OrderApi.getOrderDetails(orderId);
    setOrderDetails(response);
  }

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

  useEffect(() => {
    setIsOrderPlacedNow(queryParams.get("isOrderPlacedNow") === "true");
  }, [queryParams]);

  useEffect(() => {
    if (isOrderPlacedNow) {
      toast.success("Order placed successfully!", { toastId: "order-placed" });
    }
  }, [isOrderPlacedNow]);

  const isAskMapLocation = () => {
    if (!orderDetails) {
      return false;
    }
    if (
      [ORDER.STATUS.Delivered, ORDER.STATUS.Cancelled].includes(
        orderDetails?.status
      )
    ) {
      return false;
    }
    if (!deviceLocation) {
      // If GPS is not enabled, then not asking for location
      return false;
    }

    if (orderDetails?.customerAddress?.location) {
      // If location is already set, then not asking for location
      return false;
    }

    return true;
  };

  const handleConfirmLocation = async (location) => {
    try {
      const response = await CustomerApi.updateAddress(
        orderDetails?.customerAddress?.id,
        {
          locationDetails: location,
        }
      );
      console.log(response);
      AnalyticsService.trackEvent(EVENT_NAME.ADDRESS_MAP_LOCATION_UPDATED, {
        orderId: orderDetails?.id,
        addressId: orderDetails?.customerAddress?.id,
        location: location,
        city: orderDetails?.customerAddress?.city,
        addressLine1: orderDetails?.customerAddress?.addressLine1,
      });
      toast.success("Location updated successfully", {
        toastId: "location-updated",
      });
      setDeviceLocation(location);
      fetchOrderDetails();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <motion.div
      className="all_order_container"
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
    >
      <h1 className="all_order_title">Order Summary</h1>

      {!orderDetails ? (
        <Loader />
      ) : (
        <>
          {isAskMapLocation() && (
            <div style={{ marginBottom: "20px" }}>
              <h4 style={{ marginBottom: "10px" }}>
                Please confirm your location for faster delivery
              </h4>
              <MapComponent
                defaultCenter={deviceLocation}
                onConfirmLocation={handleConfirmLocation}
              />
            </div>
          )}
          {isOrderPlacedNow && (
            <>
              <p>
                Your order has been placed successfully. Here's what you've
                ordered:
              </p>
            </>
          )}
          <OrderItemSummary
            order={orderDetails}
            onOrderFeedbackSubmitted={() => {
              fetchOrderDetails();
            }}
          />
        </>
      )}

      {isOrderPlacedNow && (
        <div style={{ marginTop: "40px", textAlign: "center" }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <button className="close-thank-you-popup-btn">Back to Home</button>
          </Link>
        </div>
      )}

      <ToastContainer
        id="cart-toast-container"
        style={{ width: "300px", marginBottom: "10px" }}
        position="bottom-center"
        autoClose={3000}
        pauseOnHover={false}
        closeOnClick={true}
      />
    </motion.div>
  );
}
